// src/app/layout.tsx
"use client";

import { Inter } from 'next/font/google';
import Script from 'next/script';
import './globals.css';
import { AuthProvider } from '@/context/auth-context';
import { I18nProvider } from '@/context/i18n-context';
import { UIStateProvider } from '@/context/ui-state-context';
import MainLayout from '@/components/layout/main-layout';
import { cn } from '@/lib/utils';
import { Suspense } from 'react';
import Preloader from '@/components/layout/preloader';


const inter = Inter({
  variable: '--font-inter',
  subsets: ['latin'],
  display: 'swap',
});

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="en" className="dark h-full" suppressHydrationWarning>
      <head>
        <title>TalkTribe – Chat with AI Characters Free</title>
        <meta name="description" content="Create and chat with unique AI characters instantly. Enjoy unlimited, private conversations with AI chatbots – no sign-up required. Free, fun, and always open." />
        <link rel="icon" href="/favicon.png" type="image/png" />
        <link rel="manifest" href="/manifest.webmanifest" />
        <link rel="preconnect" href="https://firebasestorage.googleapis.com" />
        <link rel="preconnect" href="https://talktribe-001.firebaseapp.com" />
        <link rel="preconnect" href="https://apis.google.com" />
      </head>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-N9YK76YH8D"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-N9YK76YH8D');
        `}
      </Script>
      <Script src="https://accounts.google.com/gsi/client" async defer />
      <body className={cn(
          `${inter.variable} antialiased text-foreground h-full`
        )}>
        <I18nProvider>
          <AuthProvider>
            <UIStateProvider>
              <Preloader />
              <MainLayout>
                {children}
              </MainLayout>
            </UIStateProvider>
          </AuthProvider>
        </I18nProvider>
      </body>
    </html>
  );
}
